/* global axios */
import ApiClient from './ApiClient';

class EmailCampaignDomainsAPI extends ApiClient {
  constructor() {
    super('email_campaign_domains', { accountScoped: true });
  }

  verify(id) {
    return axios.post(`${this.url}/${id}/verify`);
  }
}

export default new EmailCampaignDomainsAPI();
